import React from 'react';

function NWSEResize({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <polyline points="19.0700073 14.8299866 19.0700073 19.0700073 14.8300018 19.0700073" />
      <path d="M4.92999268,4.92999268 L19.0700073,19.0700073" />
      <polyline points="9.16999817 4.92999268 4.92999268 4.92999268 4.92999268 9.17001343" />
    </svg>
  );
}

export default NWSEResize;
